import { RequesterType } from 'helpers/types'
import { AUTH_FRONTEND_URL, URL_SERVER_PUBLIC_SHARED_LAMBDA } from '../config'

export type SlackStateObject = {
  endpoint: 'openid/connect' | 'oauth/v2'
  redirect_uri: string
  next: string
  action: 'LOGIN' | 'SIGNUP'
  productId?: string
  requester?: RequesterType
  overrideDefaultSignupAction?: string
}

const slack = {
  connect: async (options: {
    next: SlackStateObject['next']
    action: SlackStateObject['action']
    productId?: SlackStateObject['productId']
    requester?: SlackStateObject['requester']
    overrideDefaultSignupAction?: SlackStateObject['overrideDefaultSignupAction']
  }) => {
    const state: SlackStateObject = {
      endpoint: 'openid/connect',
      redirect_uri: `${AUTH_FRONTEND_URL}/slack`,
      next: options.next,
      action: options.action,
      productId: options.productId,
      requester: options.requester,
      overrideDefaultSignupAction: options.overrideDefaultSignupAction,
    }

    const searchParams = new URLSearchParams({
      state: JSON.stringify(state),
    })

    const url = `${URL_SERVER_PUBLIC_SHARED_LAMBDA}/slack/directInstallURL?${searchParams.toString()}`

    window.location.href = url
  },
}

export default slack
